import { DashboardPageV2 } from "./DashboardPage-v2";
import { SharedUsersListProvider } from "./hooks/useSharedUsersList";

export const DashboardPageV2Container = (props) => (
    <SharedUsersListProvider>
        <DashboardPageV2 props={props} />
    </SharedUsersListProvider>
);
